import React, { useState } from "react";
import { apiFetch } from "../../../../apiFetch";
import "./MessageUsers.css";

const MessageUsers = () => {
    const [category, setCategory] = useState("all_users");
    const [message, setMessage] = useState("");

    // ✅ NEW: link fields
    const [link, setLink] = useState("");
    const [linkLabel, setLinkLabel] = useState("");

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");

    const handleSendMessage = async () => {
        if (!message.trim()) {
            setStatus("❌ Message cannot be empty.");
            return;
        }

        setLoading(true);
        setStatus("");

        try {
            
            const res = await apiFetch("/api/admin/notifications/send", {

                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    category,
                    message,
                    type: "Admin Message",

                    // ✅ send link info to backend (optional)
                    link: link.trim() || null,
                    linkLabel: linkLabel.trim() || null,
                }),
            });


            const data = await res.json().catch(() => ({}));


            if (!res.ok || data.success === false) {
                setStatus(`❌ Failed: ${data?.error || "Something went wrong"}`);
                return;
            }

            setStatus(`✅ Message sent to ${data.sentCount || 0} users!`);
            setMessage("");
            setLink("");
            setLinkLabel("");
        } catch (err) {
            console.error("❌ Error sending message:", err);
            setStatus("❌ Server error sending message.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="message-users-container">
            <h2 className="message-users-title">Message Users</h2>

            <div className="message-users-card">
                <label className="message-users-label">Select Category</label>

                <select
                    className="message-users-select"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                >
                    <option value="all_users">
                        All Users (Players, Agents, Scouts, Clubs)
                    </option>
                    <option value="role_users">Role Users (Agents, Scouts, Clubs)</option>
                    <option value="players">Players</option>
                    <option value="agents">Agents</option>
                    <option value="scouts">Scouts</option>
                    <option value="clubs">Clubs</option>
                </select>

                <label className="message-users-label">Message</label>
                <textarea
                    className="message-users-textarea"
                    placeholder="Type your message here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />

                {/* ✅ NEW: Link input */}
                <label className="message-users-label">Link (optional)</label>
                <input
                    className="message-users-input"
                    placeholder="https://example.com"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                />

                {/* ✅ NEW: Link label input */}
                <label className="message-users-label">Link Label (optional)</label>
                <input
                    className="message-users-input"
                    placeholder="View"
                    value={linkLabel}
                    onChange={(e) => setLinkLabel(e.target.value)}
                />

                <button
                    className="message-users-button"
                    onClick={handleSendMessage}
                    disabled={loading}
                >
                    {loading ? "Sending..." : "Send Message"}
                </button>

                {status && <p className="message-users-status">{status}</p>}
            </div>
        </div>
    );
};

export default MessageUsers;





